import $ from 'jquery';
import 'owl.carousel';
import MatchmakerSlider from './matchmaker-slider';

class Slider {
  constructor() {
    this.carousel = $('.js-slider');
    this.speed = 1000;
    this.slideInterval = 5000;
    this.pauseOnHover = false;

    $(document).ready(() => {
      this.carousels();
    });
  }

  static isInView(carousel) {
    const elementTop = carousel.offset().top + carousel.outerHeight() / 2;
    const elementBtm = elementTop + carousel.outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBtm = viewportTop + $(window).height();

    return elementBtm > viewportTop && elementTop < viewportBtm;
  }

  carousels() {
    if (this.carousel.length) {
      $.each(this.carousel, (i, el) => {
        const carousel = $(el);
        let inView = false;

        carousel.on('initialized.owl.carousel', () => {
          setTimeout(() => {
            $(window)
              .on('scroll', () => {
                if (!inView && Slider.isInView(carousel)) {
                  // carousel.data('owl.carousel').options.autoplay = true;
                  // carousel.trigger('refresh.owl.carousel');
                  carousel.trigger('play.owl.autoplay');
                  MatchmakerSlider.dotsAnimation(carousel);
                  carousel.addClass('is-in-view');
                  inView = true;
                }
              })
              .trigger('scroll');
          });
        });

        carousel.owlCarousel({
          items: 1,
          dots: true,
          nav: false,
          mouseDrag: true,
          touchDrag: true,
          loop: true,
          autoplay: false,
          autoplaySpeed: this.speed,
          navSpeed: this.speed,
          dotsSpeed: this.speed,
          dragEndSpeed: this.speed,
          autoplayTimeout: this.slideInterval,
          autoplayHoverPause: this.pauseOnHover,
        });

        if (this.pauseOnHover) {
          this.isPaused = false;

          carousel.on('mouseover.owl.autoplay', () => {
            if (this.pauseOnHover && !this.isPaused) {
              MatchmakerSlider.dotsPause(carousel);
              this.isPaused = true;
            }
          });

          carousel.on('mouseleave.owl.autoplay', () => {
            if (this.pauseOnHover && this.isPaused) {
              MatchmakerSlider.dotsPlay();
              this.isPaused = false;
            }
          });
        }

        carousel.on('changed.owl.carousel', () => {
          carousel.trigger('stop.owl.autoplay');
          carousel.trigger('play.owl.autoplay');
          MatchmakerSlider.dotsAnimation(carousel);
        });

        $(document).on('lity:ready', (event, instance) => {
          const opener = instance.opener();

          if (opener.hasClass('js-slide-video-btn')) {
            carousel.trigger('stop.owl.autoplay');
            carousel.find('.owl-dot').removeClass('is-animating');
          }
        });

        $(document).on('lity:close', (event, instance) => {
          const opener = instance.opener();

          if (opener.hasClass('js-slide-video-btn')) {
            carousel.trigger('play.owl.autoplay');
            carousel.find('.owl-dot.active').addClass('is-animating');
          }
        });
      });
    }
  }
}

export default new Slider();



// WEBPACK FOOTER //
// ./src/scripts/modules/slider.js